module.exports = __webpack_public_path__ + "img/hp-h1.47ca2f55.svg";